import cls from 'classnames';
import React, { InputHTMLAttributes } from 'react';
import * as styles from './Input.module.scss';

const Input: React.FC<InputProps & InputHTMLAttributes<HTMLInputElement>> = ({ error, ...props }) => {
  return <input {...props} className={cls(styles.input, { [styles.disabled]: props.disabled, [styles.error]: error })} />;
};

export default Input;
